import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { TemplateScope, TemplateType } from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { ActionTypeModel } from '../../../business-entities/action-type-model';
import { ModuleModel } from '../../../business-entities/module-model';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { TemplateDescriptionModel } from '../../../business-entities/template-description-model';
import { TemplateModel } from '../../../business-entities/template-model';
import { TemplateUsageModel } from '../../../business-entities/template-usage-model';
import { UserTypeModel } from '../../../business-entities/user-type-model';
import { TemplateBusinessService } from '../../../business-services/template-service';
import Quill from 'quill';

@Component({
  selector: 'app-add-template',
  templateUrl: './add-template.component.html',
  styleUrls: ['./add-template.component.css']
})
export class AddTemplateComponent implements OnInit {
  
  //#region Declaration

  @Input() templateId: number = 0;
  @Input() templateInfo: TemplateModel;

  moduleList: ModuleModel[];
  actionTypeList: ActionTypeModel[];
  templateUsageList: TemplateUsageModel[];
  dealerList: SelectListItemViewModel[];
  userTypeList: UserTypeModel[];
  templateTypeList: SelectListItemViewModel[];
  channelType = TemplateType;
  addTemplateForm: FormGroup;
  templateFieldList = [];
  templateField: string;
  templateScopeList = Object.keys(TemplateScope)
    .filter(key => !isNaN(Number(key)))
    .map(key => ({
      id: Number(key),
      name: TemplateScope[key]
    }));
  languageList: any[];
  selectedLanguage: any; // language object
  templateDescriptions: TemplateDescriptionModel[] = [];
  quill: Quill;
  options = {
    toolbar: {
      container: [
        [{'undo':'Undo'}, {'redo': 'Redo'}],
        [{'direction': 'rtl'}, 'blockquote'],
        [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }, { 'header': 4 }],
        ['bold', 'italic', 'strike'],
        [{'script': 'super'}, {'script': 'sub'}],
        ['link'],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        ['clean']
      ],
      handlers: {
        redo() {
          this.quill.history.redo();
        },
        undo() {
          this.quill.history.undo();
        }
      }
    },
    history: {delay: 500, maxStack: 500, userOnly: true}
  };

  //#endregion

  //#region Constructor & OnInit

  constructor(
    private editTemplateService: TemplateBusinessService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private formBuilder: FormBuilder,
    private currentLanguageService: CurrentLanguage,
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.languageList = this.currentLanguageService.LanguageList;
    this.addTemplateForm = this.formBuilder.group({
      dealerId: ['-1', Validators.required],
      templateType: [null, Validators.required],
      applicationId: [null, Validators.required],
      templateUsageId: [null, Validators.required],
      templateScope: [null],
      cc: [''],
      bcc: [''],
      actionTypeCode: [null, Validators.required],
      userTypeId: [null, Validators.required],
      isActive: [],
      template: new FormArray([])
    });
    this.GetTemplateDetails(this.templateId);
  }

  //#endregion

  //#region Page Methods

  get cpf() {
    return this.addTemplateForm.controls;
  }

  get t() { return this.cpf.template as FormArray; }

  getLanguageForm() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
      for (let i = this.t.length; i < number; i++) {
        const langId = this.currentLanguageService.LanguageList[i].id;
        this.templateDescriptions[i].languageId = langId;
        this.t.push(this.formBuilder.group({
          languageId: [langId],
          name: ['', Validators.required],
          subject: [''],
          body: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.t.removeAt(i);
      }
    }
  }

  setLists(isClear: boolean = false) {
    this.moduleList = this.templateInfo.moduleList;
    this.templateTypeList = this.templateInfo.templateTypeList;
    this.templateUsageList = this.templateInfo.templateUsageList.filter(x=>x.id != 2);
    this.dealerList = this.editTemplateService.dealerList;
    this.userTypeList = this.templateInfo.userTypeList;
    this.actionTypeList = this.templateInfo.actionTypeList;

    this.templateDescriptions = this.templateInfo.templateDescriptions;
    this.templateInfo.templateCode = 0;
    if (this.templateInfo.templateUsageId == "2") {
      this.templateInfo.templateUsageId = null;
    }
    if(isClear){
      this.templateInfo.dealerId = '-1';
      this.templateInfo.templateType = null;
      this.templateInfo.applicationId = null;
      this.templateInfo.templateUsageId = null;
      this.templateInfo.actionTypeCode = null;
      this.templateInfo.userTypeId = null;
      this.templateInfo.templateScope = null;
    }
  }

    onModuleChange(){
    const fields = this.moduleList.find(x => x.id == this.templateInfo.applicationId)
    if (fields?.templateField) {
      this.templateField = fields.templateField;
      this.templateFieldList = this.templateField.split(',');
      this.templateFieldList = this.templateFieldList.slice().sort((a, b) => {
        return (a < b ? -1 : 1);
      });
    }
    else {
      this.templateFieldList = [];
    }
  }

  disabled() {
    let isDisabled: boolean = true;
    if (this.templateInfo?.templateType == this.channelType.Sms) {
      this.t.controls.forEach(element => {
        element.get('subject').clearValidators();
      });
    }
    else{
      this.t.controls.forEach(element => {
        element.get('subject').setValidators(Validators.required);
      });
    }
    this.addTemplateForm.updateValueAndValidity();
    this.cpf.template.updateValueAndValidity();
    if (this.templateInfo && this.addTemplateForm.valid && this.cpf.template.valid) {
      isDisabled = false;
    }
    return isDisabled;
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  editBody(event) {
    this.templateInfo.body = event;
  }

  OnClose(isRefresh: boolean = false) {
    this.activeModal.close({ success: true, refresh: isRefresh });
  }

  //#endregion

  //#region API Methods

  GetTemplateDetails(templateId: number) {
    if (this.templateInfo) {
      this.setLists(false);
      this.getLanguageForm();
      this.onModuleChange();
    }
    else{
      this.spinner.show();
      this.editTemplateService.GetTemplate(templateId).then(result => {
        this.templateInfo = result.responseObject;
        this.setLists(true);
        this.getLanguageForm();
      }).finally(() => {
        this.spinner.hide();
      });
    }
  }

  SaveTemplateDetails() {
    this.spinner.show();
    let successMessage = this.translate.instant("lblTemplateAddedSuccessfully");
    let existsErrorMessage = this.translate.instant("lblTemplateAlreadyExists");
    let errorMessage = this.translate.instant("lblErrorMessage");
    this.templateInfo.templateDescriptions = this.templateDescriptions;
    this.templateInfo.templateScope = this.addTemplateForm.get('templateScope')?.value;
    this.editTemplateService.AddTemplate(this.templateInfo).then(res => {
      if (res.responseObject.errorCount == 0) {
        if (res.responseObject.result > 0) {
          this.toaster.success(successMessage);
          this.OnClose(true);
        }
        else{
          this.toaster.error(existsErrorMessage);
        } 
      }
      else{
        this.toaster.error(errorMessage);
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }
  
  OpenTemplateFieldHelp(){
    //this is intentionally
  }
  //#endregion
}
